import { render, staticRenderFns } from "./ultimateGear.vue?vue&type=template&id=386a8ee2&scoped=true"
import script from "./ultimateGear.vue?vue&type=script&lang=js"
export * from "./ultimateGear.vue?vue&type=script&lang=js"
import style0 from "./ultimateGear.vue?vue&type=style&index=0&id=386a8ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a8ee2",
  null
  
)

export default component.exports